import { camelCase } from 'lodash';
import { registerVueAsset } from 'framework/base/registry';

/**
 * Registry contexts
 *
 * This list contains all the different parts of our code which we want to auto-load.
 * At the moment, these are mostly vue-related parts, but this may change in the future.
 * The registry contexts are an async collection of `require.context` webpack calls,
 * which can be split into separate bundles for convenience.
 *
 * @type {Array}
 */
export const contexts = [
    Promise.resolve({
        context: () => require.context('@dreipol/vue-ui/src/components', true, /\.vue$/),
        register: (acc, config) => registerVueAsset(config, { namespace: 'dyn-ui', type: 'component' }),
    }),
    Promise.resolve({
        context: () => require.context('framework/global-components', true, /\.vue$/),
        register: (acc, config) => registerVueAsset(config, { namespace: 'dyn', type: 'component' }),
    }),
    Promise.resolve({
        context: () => require.context('framework/filters', true, /index\.js$/),
        register: (acc, config) => registerVueAsset(config, { type: 'filter', processName: camelCase }),
    }),
    Promise.resolve({
        context: () => require.context('@dreipol/vue-ui/src/filters', true, /(\b)+\/index\.js$/),
        register: (acc, config) => registerVueAsset(config, { type: 'filter', processName: camelCase }),
    }),
    Promise.resolve({
        context: () => require.context('framework/directives', true, /index\.js$/),
        register: (acc, config) => registerVueAsset(config, { type: 'directive' }),
    }),
];


// Add styleguide components when this route is displayed
if (window.styleguide) {
    contexts.push(new Promise(resolve => require.ensure(
        [],
        () => resolve({
            context: () => require.context('framework/styleguide', true, /\.vue$/),
            register: (acc, config) => registerVueAsset(config, { namespace: 'sty', type: 'component' }),
        }),
        null,
        'styleguide',
    )));
}

